import React, { Component } from 'react';
import classes from './Drag.module.css';

class Drag extends Component {
    state = {
        hover: true,
        angle: 0,
        a: {}, b: {}, c: {},
        currentAngle: 0,
        initAngle: 0,
        showMenu: false
    }

    rectRef = React.createRef();
    shiftX;
    shiftY;
    isDrag = false;
    resizeStartX;
    resizeStartY;
    resizeStartHeight;
    resizeStartWidth;
    resizeFuncRef


    componentDidMount() {
        this.listnerToAdd = this.closeMenu.bind(this)
        window.addEventListener("click", this.listnerToAdd)
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.listnerToAdd)
    }

    handleOnDragEnd = (event) => {
        if (this.isDrag) {
            this.isDrag = false
            const newStyle = {
                width: this.rectRef.current.style.width,
                height: this.rectRef.current.style.height,
                top: this.rectRef.current.style.top,
                left: this.rectRef.current.style.left
            }
            if (Object.keys(newStyle).some(key => newStyle[key] !== this.props.style[key])) {
                this.props.change(newStyle)
            }
        }
        window.removeEventListener('mousemove', this.handleOnDrag)
        window.removeEventListener('mouseup', this.handleOnDragEnd)
    }

    handleOnDrag = event => {
        event.preventDefault();
        if (this.isDrag) {
            const top = this.round(event.pageY - this.startPageY + this.startTop);
            const left = this.round(event.pageX - this.startPageX + this.startLeft);
            if (left + this.disLeft > this.parentBoundingClientRect.left && left + this.rectRef.current.offsetWidth - this.disLeft + this.parentBoundingClientRect.left < this.parentBoundingClientRect.width)
                this.rectRef.current.style.left = left + 'px';
            if (top + this.disTop > this.parentBoundingClientRect.top)
                this.rectRef.current.style.top = top + 'px';
            this.setState({ startTop: this.startTop, top: top })
        }
    }

    HandleOnDragStart = event => {
        this.isDrag = true
        this.startPageX = event.pageX;
        this.startPageY = event.pageY;
        this.parentBoundingClientRect = this.rectRef.current.parentElement.getBoundingClientRect()
        this.boundingClientRect = this.rectRef.current.getBoundingClientRect()
        this.startLeft = this.rectRef.current.offsetLeft;
        this.startTop = this.rectRef.current.offsetTop;
        this.disLeft = this.boundingClientRect.left - this.startLeft;
        this.disTop = this.boundingClientRect.top - this.startTop;

        this.setState({ startTop: this.startTop })

        window.addEventListener('mousemove', this.handleOnDrag)
        window.addEventListener('mouseup', this.handleOnDragEnd)
    }

    round = (num) => {
        // return num;
        return Math.round(num)
        // return Math.round(num / 10) * 10
    }

    resizeStart = (event, resizeFunc) => {
        this.resizeFuncRef = resizeFunc
        event.stopPropagation();
        this.resizeStartX = event.pageX;
        this.resizeStartY = event.pageY;
        this.resizeStartWidth = this.rectRef.current.offsetWidth
        this.resizeStartHeight = this.rectRef.current.offsetHeight
        this.resizeStartTop = this.rectRef.current.offsetTop
        this.resizeStartLeft = this.rectRef.current.offsetLeft
        window.addEventListener('mousemove', resizeFunc);
        window.addEventListener('mouseup', this.resizeEnd);
    }

    resizeRight = event => {
        let w = this.round(this.resizeStartWidth + (event.pageX - this.resizeStartX));
        if (w > this.props.minSize)
            this.rectRef.current.style.width = w + 'px';
    }

    resizeLeft = event => {
        let w = this.round(this.resizeStartWidth + (this.resizeStartX - event.pageX));
        if (w > this.props.minSize) {
            this.rectRef.current.style.width = w + 'px';
            this.rectRef.current.style.left = this.resizeStartLeft - (this.resizeStartX - event.pageX) + 'px';
        }
    }

    resizeTop = event => {
        let h = this.round(this.resizeStartHeight + (this.resizeStartY - event.pageY));
        if (h > this.props.minSize) {
            this.rectRef.current.style.top = this.resizeStartTop - (this.resizeStartY - event.pageY) + 'px';
            this.rectRef.current.style.height = h + 'px';
        }
    }

    resizeBottom = event => {
        let h = this.round(this.resizeStartHeight + (event.pageY - this.resizeStartY));
        if (h > this.props.minSize)
            this.rectRef.current.style.height = h + 'px';
    }

    resizeTopLeft = event => {
        this.resizeTop(event)
        this.resizeLeft(event)
    }

    resizeTopRight = event => {
        this.resizeTop(event)
        this.resizeRight(event)
    }

    resizeBottomLeft = event => {
        this.resizeBottom(event)
        this.resizeLeft(event)
    }

    resizeBottomRight = event => {
        this.resizeBottom(event)
        this.resizeRight(event)
    }

    resizeEnd = (event, resizeFunc) => {
        window.removeEventListener('mousemove', this.resizeFuncRef);
        window.removeEventListener('mouseup', this.resizeEnd);
        const newStyle = {
            width: this.rectRef.current?.style.width,
            height: this.rectRef.current?.style.height,
            top: this.rectRef.current?.style.top,
            left: this.rectRef.current?.style.left
        }
        if (Object.keys(newStyle).some(key => newStyle[key] !== this.props.style[key])) {
            this.props.change(newStyle)
        }
    }

    rotateStart = (event) => {
        event.stopPropagation();
        const { left, top, width, height } = this.rectRef.current.getBoundingClientRect();
        this.RectCenterX = left + width / 2;
        this.RectCenterY = top + height / 2;
        this.rotateElemX = event.target.getBoundingClientRect().left
        this.rotateElemY = event.target.getBoundingClientRect().top

        this.setState(pre => ({ initAngle: pre.initAngle + pre.currentAngle, currentAngle: 0 }))

        window.addEventListener('mousemove', this.rotateMove);
        window.addEventListener('mouseup', this.rotateEnd);
    }

    rotateMove = event => {

        const a = { x: this.RectCenterX, y: this.RectCenterY };
        const b = { x: this.rotateElemX, y: this.rotateElemY };
        const c = { x: event.clientX, y: event.clientY };

        const getD = (pointA, pointB) => {
            var distance = Math.sqrt((Math.pow(pointA.x - pointB.x, 2)) + (Math.pow(pointA.y - pointB.y, 2)))
            return distance;
        }

        const directionOfPoint = (A, B, P) => {
            return Math.sign((B.x - A.x) * (P.y - A.y) - (B.y - A.y) * (P.x - A.x))
        }

        const ab = getD(a, b);
        const bc = getD(b, c);
        const ac = getD(a, c);

        let angle = Math.acos((ab * ab + ac * ac - bc * bc) / (2 * ab * ac));
        angle = Math.round(angle * 100) / 100
        if (directionOfPoint(a, b, c) < 0) {
            angle = -1 * angle
        }
        this.setState({ angle: angle, a: a, b: b, c: c, currentAngle: angle })

        this.rectRef.current.style.transform = `rotate(${this.state.currentAngle + this.state.initAngle}rad)`;


    }

    rotateEnd = () => {
        window.removeEventListener('mousemove', this.rotateMove);
        window.removeEventListener('mouseup', this.rotateEnd);
        this.props.change({
            transform: this.rectRef.current.style.transform,
        })
    }

    openMenu = (event) => {
        event.preventDefault();
        const boundingClientRect = this.rectRef.current.getBoundingClientRect()
        this.setState({ showMenu: true, menuLeft: `${event.pageX - boundingClientRect.left}px`, menuTop: `${event.pageY - boundingClientRect.top}px` })
    }

    closeMenu() {
        this.setState({ showMenu: false })
    }

    render() {
        return (
            <div
                className={classes.Rect}
                style={this.props.style}
                draggable={false}
                onMouseDown={(e) => { this.HandleOnDragStart(e); e.stopPropagation() }}
                onContextMenu={this.openMenu}
                ref={this.rectRef}>
                <div className={classes.EditBorder}>
                    <div className={`${classes.Resize} ${classes.ResizeRight}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeRight); }}></div>
                    <div className={`${classes.Resize} ${classes.ResizeLeft}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeLeft); }}></div>
                    {!this.props.disableHeightChange && <div className={`${classes.Resize} ${classes.ResizeTop}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeTop); }}></div>}
                    {!this.props.disableHeightChange && <div className={`${classes.Resize} ${classes.ResizeBottom}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeBottom); }}></div>}
                    {!this.props.disableCornersChange && <div className={`${classes.Resize} ${classes.ResizeTopLeft}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeTopLeft); }}></div>}
                    {!this.props.disableCornersChange && <div className={`${classes.Resize} ${classes.ResizeTopRight}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeTopRight); }}></div>}
                    {!this.props.disableCornersChange && <div className={`${classes.Resize} ${classes.ResizeBottomLeft}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeBottomLeft); }}></div>}
                    {!this.props.disableCornersChange && <div className={`${classes.Resize} ${classes.ResizeBottomRight}`} onMouseDown={(e) => { this.resizeStart(e, this.resizeBottomRight); }}></div>}
                    {!this.props.disableRotate && <div className={classes.Rotate} onMouseDown={this.rotateStart}></div>}
                </div>
                {this.state.showMenu && <div className={classes.Menu} style={{ left: this.state.menuLeft, top: this.state.menuTop }}>
                    {/* <div className={classes.MenuTab} onClick={() => this.props.onBringForward(this.props.id)}>הבא קדימה</div> */}
                    {/* <div className={classes.MenuTab} onClick={() => this.props.onSendBackward(this.props.id)}>העבר אחורה</div> */}
                    {/* <div className={classes.MenuTab} onClick={() => this.props.onBringToFront(this.props.id)}>הבא לחזית</div> */}
                    {/* <div className={classes.MenuTab} onClick={() => this.props.onSendToBack(this.props.id)}>העבר לרקע</div> */}
                    <div className={classes.MenuTab} onClick={() => this.props.onRemoveRect()}>מחק</div>
                </div>}
                <div className={classes.Content} >
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default Drag;